import { useEffect, useState } from 'react';
import { ServicioProxyTransar } from './../components/base/servicioProxyTransar';
import { newsMock } from './newsMock';

// eslint-disable-next-line no-undef
const CANTIDAD_PRIMARIAS_VAR = typeof CANTIDAD_PRIMARIAS !== 'undefined' ? CANTIDAD_PRIMARIAS : 2;
// eslint-disable-next-line no-undef
const CANTIDAD_SECUNDARIAS_VAR = typeof CANTIDAD_SECUNDARIAS !== 'undefined' ? CANTIDAD_SECUNDARIAS : 2;

export const useFetchNews = (URL_NOTICIA_VAR) => {
  const [data, setData] = useState({
    primaryNews: [],
    secundaryNews: [],
  });
  const [loadingState, setLoadingState] = useState({
    loading: true,
    error: false,
  });

  useEffect(() => {
    const getNews = () => {
      const url = 'UtilidadSharepointGetFilter';
      const urlToService = new ServicioProxyTransar(url);
      const params = {
        Accion: 'GET',
        Lista: 'Páginas',
        UrlSitio: window.location.origin + URL_NOTICIA_VAR,
        Campos: {
          Query: [
            {
              NombreInternoCampo: 'FechaInicio',
              Valor: '<Today />',
              Tipo: 'DateTime',
              Filtro: 'Leq',
            },
            {
              NombreInternoCampo: 'FechaFin',
              Valor: '<Today />',
              Tipo: 'DateTime',
              Filtro: 'Geq',
            },
            {
              NombreInternoCampo: 'Mostrar',
              Valor: 1,
              Tipo: 'Boolean',
              Filtro: 'Eq',
            },
          ],
        },
        Vista: [
          'PublishingPageImage',
          'Title',
          'Comments',
          'DescripcionNoticia',
          'ColorTitulo',
          'NuevaVentana',
          'Detalle',
          'FechaFin',
          'FechaInicio',
          'ColorDetalle',
          'Mostrar',
          'Ordenar',
          'FileRef',
        ],
        orden: [
          { Item1: 'Ordenar', Item2: true },
          { Item1: 'FechaInicio', Item2: false },
        ],
      };
      urlToService
        .getElements('POST', params)
        .then((response) => {
          const [primaryNews, secundaryNews] = castData(response);
          setData(() => {
            return { primaryNews, secundaryNews };
          });
          setLoadingState((loadingState) => ({
            ...loadingState,
            loading: false,
          }));
        })
        .catch((error) => {
          setData(() => {
            return { error, primaryNews: [] };
          });
          setLoadingState((loadingState) => ({
            ...loadingState,
            loading: false,
            error: true,
          }));
        });
    };
    const getNewsMock = () => {
      const [primaryNews, secundaryNews] = castData(newsMock);
      setData(() => {
        return { primaryNews, secundaryNews };
      });
      setLoadingState((loadingState) => ({
        ...loadingState,
        loading: false,
      }));
    };
    // getNews();
    // if (import.meta.env.MODE === 'development') {
    if (window.location.hostname === '127.0.0.1') {
      getNewsMock();
    } else {
      getNews();
    }
  }, []);

  const castData = ({ Result }) => {
    const resTemp = Result.Resultado.map((item) => {
      const itemFixed = {};
      item.Valores.forEach((campo) => {
        itemFixed[campo.NombreInternoCampo] = campo.Valor;
      });
      return {
        ID: item.ID,
        ...itemFixed,
      };
    });
    const fixedFields = resTemp.map((item) => {
      let fechaString = item.FechaInicio;
      fechaString = fechaString.replace(/a\. m\.|p\. m\./i, ""); // Elimina "a. m." o "p. m." sin importar mayúsculas o minúsculas
      let fechaCompleta = new Date(fechaString);
      const dia = fechaCompleta.getDate();
      const mes = fechaCompleta.getMonth() + 1;
      const anio = fechaCompleta.getFullYear();
      // YYYY-MM-DD
      const fechaConGuiones = `${anio}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`;

      // Ahora con formato
      const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      const mesesTexto = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre',
      ];
      // Obtener el nombre del día de la semana y del mes
      const nombreDiaSemana = diasSemana[fechaCompleta.getDay()];
      const nombreMes = mesesTexto[mes - 1];
      // "Lunes, 1 de junio de 2023"
      const fechaConFormato = `${nombreDiaSemana}, ${dia} de ${nombreMes} de ${anio}`;

      // Expresión regular para extraer el contenido del atributo src
      const imgString = item.PublishingPageImage;
      const srcRegex = /src="(.*?)"/;
      const srcMatch = imgString.match(srcRegex);
      const srcString = srcMatch ? srcMatch[1] : null;

      // Expresión regular para extraer el contenido del atributo alt
      const altRegex = /alt="(.*?)"/;
      const altMatch = imgString.match(altRegex);
      const altString = altMatch ? altMatch[1] : null;

      return {
        ...item,
        fechaConGuiones,
        fechaConFormato,
        srcString,
        altString,
      };
    });
    const primaryNews = [];
    const secundaryNews = [];
    for (let i = 0; i < fixedFields.length; i++) {
      const element = fixedFields[i];
      if (i < CANTIDAD_PRIMARIAS_VAR) {
        primaryNews.push(element);
      } else if (i < (CANTIDAD_SECUNDARIAS_VAR + CANTIDAD_PRIMARIAS_VAR)) {
        secundaryNews.push(element);
      }
    }
    return [primaryNews, secundaryNews];
  };

  return [data, loadingState];
};
